<p class="footer-dark">
  <a href="https://www.sandiegocounty.gov/probation/" class="footer-dark">San Diego Probation</a>
  |
  <a routerLink="/contact-us" class="footer-dark" tabindex="0">Contact Us</a>
  @if (footerBuildInfo$ | async; as footerBuildInfo) {
    <br>
    <small class="footer-build-info">
      {{ footerBuildInfo.clientLabel }} | {{ footerBuildInfo.serverLabel }}
    </small>
  }
</p>
